<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>个人桩管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-form size="mini" class="search_form">
              <el-row>
                <el-col :span="2" style="float: right">
                  <el-button size="medium" @click="show3 = !show3" type="primary" class="el-btn">
                    搜索<i class="el-icon-caret-bottom el-icon--right"></i>
                  </el-button>
                </el-col>
                <el-col :span="3" style="float: right">
                  <el-button size="medium" type="primary" @click="dialogFormVisible = true" icon="el-icon-plus"
                             class="el-btn">
                    登记个人桩
                  </el-button>
                </el-col>
              </el-row>
              <!-- 编辑界面 -->
              <el-dialog title="登记个人桩" :visible.sync="dialogFormVisible" :modal-append-to-body='false'>
                <el-form :model="form" style="height: 400px;overflow: auto">
                  <el-form-item label="桩体名称" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="桩体编号" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="所属用户" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="所在省" :label-width="formLabelWidth">
                    <el-select placeholder="所在省">
                      <el-option label="北京" value="1"></el-option>
                      <el-option label="上海" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所在市" :label-width="formLabelWidth">
                    <el-select placeholder="所在市">
                      <el-option label="北京" value="1"></el-option>
                      <el-option label="上海" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="县/区" :label-width="formLabelWidth">
                    <el-select placeholder="县/区">
                      <el-option label="北京" value="1"></el-option>
                      <el-option label="上海" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="充电桩状态" :label-width="formLabelWidth">
                    <el-select placeholder="请选择">
                      <el-option label="对外开放" value="1"></el-option>
                      <el-option label="暂不对外开放" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="创建时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="val_time" type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                  <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
                </div>
              </el-dialog>
              <!--搜索框-->
              <el-row v-show="show3">
                <el-col :span="5">
                  <el-form-item>
                    <el-input placeholder="桩体名称" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-input placeholder="所属用户" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-input placeholder="桩体编号" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-show="show3">
                <el-col :span="2" style="float: right">
                  <el-form-item>
                    <el-button size="small" class="el_clear" icon="el-icon-close">清空</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="1.5" style="float: right">
                  <el-form-item>
                    <el-button size="small" class="el_search" icon="el-icon-search">查询</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!--列表数据-->
            <el-tab-pane label="个人桩列表" name="stationList">
              <el-table :data="views" stripe style="width: 100%">
                <!--<af-table-column type="selection"></af-table-column>-->
                <af-table-column prop="" label="桩体名称"></af-table-column>
                <af-table-column prop="" label="桩体编号"></af-table-column>
                <af-table-column prop="" label="所属用户"></af-table-column>
                <af-table-column prop="" label="运营状态"></af-table-column>
                <af-table-column prop="" label="创建时间"></af-table-column>

                <af-table-column label="操作">
                  <template slot-scope="scope">
                    <!--<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
                    <!--<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
                  </template>
                </af-table-column>
              </el-table>
              <!--工具条-->
              <el-col :span="24" class="toolbar">
                <!--                <el-button align="left" type="danger">批量修改</el-button>-->
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                               :total="total" style="float:right;">
                </el-pagination>
              </el-col>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'personPileManager',
    data() {
      return {
        activeName: 'stationList',
        show3: false,
        input: '',
        dialogFormVisible: false,
        val_time: '',
        formLabelWidth: '120px'
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },
      handleEdit(index, row) {
        console.log(index, row)
      },
      handleDelete(index, row) {
        console.log(index, row)
      }
    }
  }
</script>

<style scoped lang="less">
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/personPileManager.vue